import { Component, Inject } from '@angular/core';
import { AngularFireDatabase } from '@angular/fire/compat/database';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { environment } from 'src/environment';
import { NotificationBar } from 'src/services/notification.service';

@Component({
  selector: 'app-settings-name',
  templateUrl: './settings-name.component.html',
  styleUrl: './settings-name.component.scss'
})
export class SettingsNameComponent {
  workspaceGroup = new FormGroup({
    nameControl: new FormControl('', [Validators.required, Validators.minLength(2), Validators.maxLength(16)]),
  });
  isProcessing = false;
  notificationBar: NotificationBar;
  workspaceID = ""
  
  constructor(public dialogRef: MatDialogRef<SettingsNameComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private snackBar: MatSnackBar, private db: AngularFireDatabase) {
    this.notificationBar = new NotificationBar(snackBar);
    this.workspaceID = data.workspaceID;
  }

  ngOnInit() {

  }

  async updateWorkspaceName() {
    this.isProcessing = true;
    var newName = this.workspaceGroup.controls.nameControl.value;
    var workspaceDBRef = this.db.database.app.database(environment.emsDatabaseURL).ref('/workspaces/' + this.workspaceID);
    var workspaceUpdates = {};
    workspaceUpdates['name'] = newName;
    workspaceDBRef.update(workspaceUpdates).then( () => {
      this.isProcessing = false;
      this.notificationBar.show("Workspace Name changed!");
      this.dialogRef.close(newName);
    }).catch( err => {
      this.isProcessing = false;
      if (err.code == "PERMISSION_DENIED") {
        this.notificationBar.show("Missing permission!");
      }
      else {
        this.notificationBar.showUnknownError();
      }
    });
  }

  getErrorName() {
    if (this.workspaceGroup.controls.nameControl.hasError('maxlength')) {
      return 'Maximum 16 characters'
    }
    else return this.workspaceGroup.controls.nameControl.hasError('minlength') ? 'Use 2 characters or more' : '';
  } 
}
